module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Снижение тарифов на Виртуальные карты USA Capitalist!"},"en":{"Напомнить позже":"Remind me later","title":"Reduced fees for Capitalist Virtual cards USA!","Выпуск карты":"Card issue","Пополнение карты":"Card top-up","Ежемесячное обслуживание":"Monthly maintenance","Плата за транзакцию":"Transaction fee","Закрыть":"Close"}}')
  delete Component.options._Ctor
}
